import Stack from '@mui/material/Stack'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

export const LoadingLayout = ({ message = 'Loading...' }: { message?: string }) => {
    return (
        <Stack alignItems="center" justifyContent="center" height="100vh" gap={2} data-testid="loading-stack-circular-progress">
            <CircularProgress data-testid="loading-circular-progress" />
            <Typography variant="body2" color="text.secondary" data-testid="loading-typography">
                {message}
            </Typography>
        </Stack>
    )
}
